import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable, of, tap } from 'rxjs'
import { environment } from '@environments/environment'
import { Country } from '@shared/models/country.model'

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  private readonly http = inject(HttpClient)
  private readonly apiUrl = environment.referenceApiUrl

  private readonly countries$$ = new BehaviorSubject<Country[]>([])
  public readonly countries$ = this.countries$$.asObservable()

  private hasLoaded = false

  /**
   * Fetches the currency list from the API, but only if it hasn't been loaded before.
   * This prevents multiple API calls during the app's lifecycle.
   */
  public loadCountries(): Observable<Country[]> {
    if (this.hasLoaded) {
      return of(this.countries$$.getValue()) // Return the already loaded data
    }

    return this.http.get<Country[]>(`${this.apiUrl}/country`).pipe(
      tap(countries => {
        this.countries$$.next(countries)
        this.hasLoaded = true
      })
    )
  }
}
